import React, { useContext, useEffect, useState } from "react";

import moment from "moment";
import { GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";

import Fancybox from "./Fancybox";
import { Card, CardBody } from "./card/card";
import { AppSettings } from "../config/app-settings";
import apiClient from "../ApiClient";
import toastMessage from "./ToastMessage";

const center = { lat: 39.1667, lng: 35.6667 };
const defaultZoom = 5.8;
let options;
setTimeout(() => {
  options = {
    center,
    zoom: defaultZoom,
    styles:
      document.querySelector("html").getAttribute("data-bs-theme") === "light"
        ? []
        : [
            {
              featureType: "all",
              elementType: "all",
              stylers: [
                { invert_lightness: true },
                { saturation: -50 },
                { lightness: 40 },
                { gamma: 0.5 },
                {
                  hue: window.location.host.includes("datakokpit")
                    ? "#17248a"
                    : "#3cd2a5",
                },
              ],
            },
          ],
  };
}, 3000);

export default function AnketCevaplariModal({
  data,
  handleReportDetail,
  reportMapShow,
  setReportMapShow,
  reportSelectedAnswerMarker,
  setReportSelectedAnswerMarker,
  reportSelectedMarker,
  setReportSelectedMarker,
}) {
  const context = useContext(AppSettings);

  const [itemLocation, setItemLocation] = useState(null);

  const [allDistrict, setAllDistrict] = useState([]);
  const [allNeighborhood, setAllNeighborhood] = useState([]);

  async function fetchDistrict(value) {
    setAllDistrict([]);

    if (value) {
      const data = await context.getAllDistrict(value);

      if (data) {
        setAllDistrict(data);
      }
    } else {
      setAllDistrict([]);
    }
  }

  async function fetchNeighborhood(value) {
    setAllNeighborhood([]);

    if (value) {
      const data = await context.getAllNeighborhood(value);

      if (data) {
        setAllNeighborhood(data);
      }
    } else {
      setAllNeighborhood([]);
    }
  }

  async function handlePhoneControl(status) {
    try {
      const response = await apiClient.put(
        `/street-report-reply/${data.id}/tk`,
        {
          tk: status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response) {
        toastMessage(context?.t?.telefon_kontrol_edildi, "success");
        handleReportDetail(data, true);
      }
    } catch (error) {
      console.error("Note Add Error", error);
    }
  }

  useEffect(() => {
    if (data) {
      fetchDistrict(data.city);
      fetchNeighborhood(data.district);
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <div className="modal-body pt-0">
      {data ? (
        <div className="row gap-4 mb-4">
          <div className="col-12">
            {reportMapShow && (
              <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ zIndex: 99, background: "var(--bs-dark3)" }}
              >
                <div className="p-3 w-100 h-100">
                  <button
                    className="btn btn-outline-theme mb-3"
                    onClick={() => {
                      setReportMapShow(false);
                      setReportSelectedMarker(null);
                      setItemLocation(null);
                    }}
                  >
                    {context?.t?.haritayi_gizle}
                  </button>

                  <GoogleMap
                    mapContainerStyle={{
                      height: "100%",
                      width: "100%",
                    }}
                    options={options}
                  >
                    {itemLocation
                      ? itemLocation.answer.images &&
                        itemLocation.answer.images.length !== 0 &&
                        itemLocation.answer.images.map((img, imgIndex) => (
                          <>
                            <Marker
                              key={imgIndex}
                              position={{
                                lat: parseFloat(img.location.lat),
                                lng: parseFloat(img.location.lng),
                              }}
                              onClick={() => {
                                setReportSelectedMarker(img);
                                setReportSelectedAnswerMarker(itemLocation);
                              }}
                            />

                            {reportSelectedMarker && (
                              <InfoWindow
                                onCloseClick={() => {
                                  setReportSelectedMarker(null);
                                  setItemLocation(null);
                                }}
                                position={{
                                  lat: parseFloat(
                                    reportSelectedMarker.location.lat
                                  ),
                                  lng: parseFloat(
                                    reportSelectedMarker.location.lng
                                  ),
                                }}
                              >
                                <div className="text-start">
                                  <span className="d-block mb-4">
                                    {context?.t?.category}:{" "}
                                    {reportSelectedAnswerMarker?.category.name}
                                    <br />
                                    {context?.t?.question}:{" "}
                                    {
                                      reportSelectedAnswerMarker?.question
                                        .question
                                    }
                                    <br />
                                    {context?.t?.answer}:{" "}
                                    {
                                      reportSelectedAnswerMarker?.answer?.answer
                                        ?.answer
                                    }
                                  </span>
                                  <span className="d-block mb-4">
                                    {context?.t?.description}:{" "}
                                    {reportSelectedMarker.description}
                                  </span>
                                  <div
                                    className="carousel slide"
                                    id={`anket-reply-detail-${1}-img-${imgIndex}`}
                                  >
                                    <div className="carousel-inner">
                                      <Fancybox
                                        options={{
                                          Carousel: {
                                            infinite: false,
                                          },
                                        }}
                                      >
                                        {reportSelectedMarker.list.map(
                                          (imgList, imgListIndex) => (
                                            <div
                                              className={`carousel-item${
                                                imgListIndex === 0
                                                  ? " active"
                                                  : ""
                                              }`}
                                            >
                                              <a
                                                data-fancybox={
                                                  img.description + "-gallery"
                                                }
                                                href={imgList}
                                                key={imgListIndex}
                                                className="col-6"
                                              >
                                                <img
                                                  className="w-100"
                                                  src={imgList}
                                                  alt={
                                                    imgListIndex +
                                                    "_" +
                                                    img.description
                                                  }
                                                />
                                              </a>
                                            </div>
                                          )
                                        )}
                                      </Fancybox>
                                    </div>

                                    <button
                                      className="carousel-control-prev"
                                      type="button"
                                      data-bs-target={`#anket-reply-detail-${1}-img-${imgIndex}`}
                                      data-bs-slide="prev"
                                    >
                                      <span
                                        className="carousel-control-prev-icon"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="visually-hidden">
                                        {context?.t?.prev}
                                      </span>
                                    </button>

                                    <button
                                      className="carousel-control-next"
                                      type="button"
                                      data-bs-target={`#anket-reply-detail-${1}-img-${imgIndex}`}
                                      data-bs-slide="next"
                                    >
                                      <span
                                        className="carousel-control-next-icon"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="visually-hidden">
                                        {context?.t?.next}
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </InfoWindow>
                            )}
                          </>
                        ))
                      : data?.reply[0].map(
                          (item, index) =>
                            item.answer.images &&
                            item.answer.images.length !== 0 &&
                            item.answer.images.map((img, imgIndex) => (
                              <>
                                <Marker
                                  key={imgIndex}
                                  position={{
                                    lat: parseFloat(img.location.lat),
                                    lng: parseFloat(img.location.lng),
                                  }}
                                  onClick={() => {
                                    setReportSelectedMarker(img);
                                    setReportSelectedAnswerMarker(item);
                                  }}
                                />

                                {reportSelectedMarker && (
                                  <InfoWindow
                                    onCloseClick={() => {
                                      setReportSelectedMarker(null);
                                      setItemLocation(null);
                                    }}
                                    position={{
                                      lat: parseFloat(
                                        reportSelectedMarker.location.lat
                                      ),
                                      lng: parseFloat(
                                        reportSelectedMarker.location.lng
                                      ),
                                    }}
                                  >
                                    <div className="text-start">
                                      <span className="d-block mb-4">
                                        {context?.t?.category}:{" "}
                                        {
                                          reportSelectedAnswerMarker?.category
                                            .name
                                        }
                                        <br />
                                        {context?.t?.question}:{" "}
                                        {
                                          reportSelectedAnswerMarker?.question
                                            .question
                                        }
                                        <br />
                                        {context?.t?.answer}:{" "}
                                        {
                                          reportSelectedAnswerMarker?.answer
                                            .answer?.answer
                                        }
                                      </span>

                                      <span className="d-block mb-4">
                                        {context?.t?.description}:
                                        {reportSelectedMarker.description}
                                      </span>

                                      <div
                                        className="carousel slide"
                                        id={`anket-reply-detail-${index}-img-${imgIndex}`}
                                      >
                                        <div className="carousel-inner">
                                          <Fancybox
                                            options={{
                                              Carousel: {
                                                infinite: false,
                                              },
                                            }}
                                          >
                                            {reportSelectedMarker.list.map(
                                              (imgList, imgListIndex) => (
                                                <div
                                                  className={`carousel-item${
                                                    imgListIndex === 0
                                                      ? " active"
                                                      : ""
                                                  }`}
                                                >
                                                  <a
                                                    data-fancybox={
                                                      img.description +
                                                      "-gallery"
                                                    }
                                                    href={imgList}
                                                    key={imgListIndex}
                                                    className="col-6"
                                                  >
                                                    <img
                                                      className="w-100"
                                                      src={imgList}
                                                      alt={
                                                        imgListIndex +
                                                        "_" +
                                                        img.description
                                                      }
                                                    />
                                                  </a>
                                                </div>
                                              )
                                            )}
                                          </Fancybox>
                                        </div>

                                        <button
                                          className="carousel-control-prev"
                                          type="button"
                                          data-bs-target={`#anket-reply-detail-${index}-img-${imgIndex}`}
                                          data-bs-slide="prev"
                                        >
                                          <span
                                            className="carousel-control-prev-icon"
                                            aria-hidden="true"
                                          ></span>
                                          <span className="visually-hidden">
                                            {context?.t?.prev}
                                          </span>
                                        </button>

                                        <button
                                          className="carousel-control-next"
                                          type="button"
                                          data-bs-target={`#anket-reply-detail-${index}-img-${imgIndex}`}
                                          data-bs-slide="next"
                                        >
                                          <span
                                            className="carousel-control-next-icon"
                                            aria-hidden="true"
                                          ></span>
                                          <span className="visually-hidden">
                                            {context?.t?.next}
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                  </InfoWindow>
                                )}
                              </>
                            ))
                        )}
                  </GoogleMap>
                </div>
              </div>
            )}

            <hr />

            <div className="text-start">
              <div className="d-block">
                {context?.t?.address}:{" "}
                <ol className="d-inline-flex breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    {
                      context.allCity.find(function (item) {
                        return item.value === data.city;
                      })?.label
                    }
                  </li>
                  <li className="breadcrumb-item">
                    {allDistrict.length !== 0 &&
                      allDistrict.find(function (item) {
                        return item.value === data.district;
                      })?.label}
                  </li>
                  <li className="breadcrumb-item">
                    {allNeighborhood.length !== 0 &&
                      allNeighborhood.find(function (item) {
                        return item.value === data.neighbourhood;
                      })?.label}
                  </li>
                  <li className="breadcrumb-item">{data?.street}</li>
                  {data?.building && (
                    <li className="breadcrumb-item">{data?.building}</li>
                  )}
                  {data?.independent && (
                    <li className="breadcrumb-item">{data?.independent}</li>
                  )}
                </ol>
              </div>
              <span className="d-block">
                {context?.t?.olusturma_tarihi}:{" "}
                {moment(data.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "DD MMMM YYYY"
                )}
              </span>
              <span className="d-block">
                {context?.t?.guncelleme_tarihi}:{" "}
                {moment(data.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                  "DD MMMM YYYY"
                )}
              </span>
            </div>

            <hr />

            <h4 className="d-block mb-3">{context?.t?.kullanici_bilgileri}</h4>

            <div className="table-responsive">
              <table className="table border mb-0 align-middle">
                <thead>
                  <tr>
                    {(context?.me?.role?.id === 1 ||
                      context?.me?.role?.id === 2) && (
                      <th
                        className="border-bottom border-end px-2"
                        style={{ width: 130 }}
                      >
                        {context?.t?.phone_control}
                      </th>
                    )}
                    <th className="border-bottom px-2">
                      {context?.t?.name_surname}
                    </th>
                    <th className="border-bottom border-start px-2">
                      {context?.t?.username}
                    </th>
                    <th className="border-bottom border-start px-2">
                      {context?.t?.role}
                    </th>
                    <th className="border-bottom border-start px-2">
                      {context?.t?.email}
                    </th>
                    <th className="border-bottom border-start px-2">
                      {context?.t?.phone}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {(context?.me?.role?.id === 1 ||
                      context?.me?.role?.id === 2) && (
                      <td
                        className="border-end"
                        onClick={() => handlePhoneControl(!data.tk)}
                      >
                        {data.tk ? (
                          <span className="btn btn-outline-theme btn-sm">
                            {context?.t?.yapildi}
                          </span>
                        ) : (
                          <span className="btn btn-danger btn-sm">
                            {context?.t?.yapilmadi}
                          </span>
                        )}
                      </td>
                    )}
                    <td>{data.user.name}</td>
                    <td className="border-start">{data.user.username}</td>
                    <td className="border-start">{data.user.role.name}</td>
                    <td className="border-start">{data.user.email}</td>
                    <td className="border-start">{data.user.phone}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <hr />

            <div className="row g-3">
              <div className="col">
                <h4 className="d-block mb-3">
                  {data.report.name}{" "}
                  <span className="h5">
                    / {context?.t?.toplam_soru}: {data?.reply[0].length}
                  </span>
                </h4>
              </div>

              <div className="col w-auto flex-none">
                <button
                  className="btn btn-outline-theme"
                  onClick={() => {
                    setReportMapShow(true);
                    setItemLocation(null);
                  }}
                >
                  {context?.t?.all_locations_show}
                </button>
              </div>
            </div>

            <div className="row g-2">
              {data?.reply[0].map((item, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-3">
                  <Card className="h-100">
                    <CardBody className="d-flex flex-column overflow-hidden">
                      <div className="row text-white border-bottom pb-2 mb-3">
                        <span className="col">
                          <span className="fw-bold h5">{index + 1}.</span>{" "}
                          {context?.t?.question}
                        </span>
                        <span className="col text-end">
                          {item?.category?.name}
                        </span>
                      </div>
                      <div
                        className="flex-1"
                        style={{
                          maxHeight: 350,
                          overflowY: "auto",
                          overflowX: "hidden",
                          paddingRight: 10,
                          marginRight: -10,
                        }}
                      >
                        <div>
                          <span className="d-block h5 mb-3">
                            {item?.question?.question}
                          </span>
                        </div>

                        <div>
                          <div
                            className="d-flex flex-wrap gap-1"
                            style={{ borderRadius: 8 }}
                          >
                            <span
                              style={{ background: "var(--bs-dark2)" }}
                              className={`pe-none py-1 px-2 rounded fw-bold text-white`}
                            >
                              {item.answer.text ? (
                                item.answer.text
                              ) : item?.answer?.answer?.answer?.includes(
                                  "|*|"
                                ) ? (
                                <div className="w-100">
                                  <Fancybox
                                    options={{
                                      Carousel: {
                                        infinite: false,
                                      },
                                    }}
                                  >
                                    <a
                                      className="d-block rounded overflow-hidden"
                                      style={{ width: 150, height: 80 }}
                                      href={
                                        item.answer.answer.answer.split(
                                          "|*|"
                                        )[0]
                                      }
                                      data-fancybox
                                    >
                                      <img
                                        src={
                                          item.answer.answer.answer.split(
                                            "|*|"
                                          )[0]
                                        }
                                        className="w-100 h-100 img-cover"
                                        alt={
                                          item.answer.answer.answer.split(
                                            "|*|"
                                          )[1]
                                        }
                                      />
                                    </a>
                                  </Fancybox>
                                  {item.answer.answer.answer.split("|*|")[1]}
                                </div>
                              ) : (
                                item.answer.answer.answer
                              )}
                              {item?.answer?.status?.is_solved && (
                                <i className="fas fa-lg fa-check-circle text-theme ms-2"></i>
                              )}
                            </span>
                          </div>
                        </div>

                        <div>
                          {item.answer.images &&
                          item.answer.images.length !== 0 ? (
                            <>
                              <hr />

                              {item.answer.images.map((img, imgIndex) => (
                                <div key={imgIndex}>
                                  <span className="d-block my-2">
                                    {context?.t?.description}: {img.description}
                                  </span>

                                  <Fancybox
                                    options={{
                                      Carousel: {
                                        infinite: false,
                                      },
                                    }}
                                  >
                                    <div
                                      className="carousel slide"
                                      id={`anket-reply-list-${index}-item-${imgIndex}`}
                                    >
                                      <div className="carousel-inner">
                                        {img.list.map(
                                          (imgList, imgListIndex) => (
                                            <div
                                              className={`carousel-item${
                                                imgListIndex === 0
                                                  ? " active"
                                                  : ""
                                              }`}
                                            >
                                              <a
                                                data-fancybox={
                                                  img.description + "-gallery"
                                                }
                                                href={imgList}
                                                key={imgListIndex}
                                                className="col-6"
                                              >
                                                <img
                                                  className="w-100 img-cover border"
                                                  style={{ height: 200 }}
                                                  src={imgList}
                                                  alt={
                                                    imgListIndex +
                                                    "_" +
                                                    img.description
                                                  }
                                                />
                                              </a>
                                            </div>
                                          )
                                        )}
                                      </div>

                                      {img.list.length > 1 && (
                                        <>
                                          <button
                                            className="carousel-control-prev"
                                            type="button"
                                            data-bs-target={`#anket-reply-list-${index}-item-${imgIndex}`}
                                            data-bs-slide="prev"
                                          >
                                            <span
                                              className="carousel-control-prev-icon"
                                              aria-hidden="true"
                                            ></span>
                                            <span className="visually-hidden">
                                              {context?.t?.prev}
                                            </span>
                                          </button>

                                          <button
                                            className="carousel-control-next"
                                            type="button"
                                            data-bs-target={`#anket-reply-list-${index}-item-${imgIndex}`}
                                            data-bs-slide="next"
                                          >
                                            <span
                                              className="carousel-control-next-icon"
                                              aria-hidden="true"
                                            ></span>
                                            <span className="visually-hidden">
                                              {context?.t?.next}
                                            </span>
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </Fancybox>
                                </div>
                              ))}

                              <button
                                className="btn btn-outline-theme mt-2"
                                onClick={() => {
                                  setItemLocation(item);
                                  setReportMapShow(true);
                                }}
                              >
                                {context?.t?.locations_show}
                              </button>
                            </>
                          ) : (
                            <span className="d-block mt-3">
                              {context?.t?.resim_yok}
                            </span>
                          )}
                        </div>

                        {item?.answer?.status?.image &&
                          item?.answer?.status?.image !== "https://-.com/" && (
                            <>
                              <hr />

                              <span className="d-block mb-2">
                                {context?.t?.guncel_hali}
                              </span>

                              <Fancybox
                                options={{
                                  Carousel: {
                                    infinite: false,
                                  },
                                }}
                              >
                                <a
                                  data-fancybox={
                                    item?.answer?.status?.image + "-gallery"
                                  }
                                  href={item?.answer?.status?.image}
                                  className="d-block"
                                >
                                  <img
                                    className="w-100 img-cover border"
                                    style={{ height: 200 }}
                                    src={item?.answer?.status?.image}
                                    alt={item?.answer?.status?.image}
                                  />
                                </a>
                              </Fancybox>
                            </>
                          )}
                      </div>
                    </CardBody>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="spinner-border text-theme"></div>
      )}
    </div>
  );
}
